(function() {
  'use strict';
  if (window.location.pathname.indexOf('/products/') === -1) return;

  var MINI_ICONS = {
    'Carte graphique': '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><rect x="2" y="6" width="20" height="12" rx="2"/><rect x="6" y="10" width="4" height="4" rx="0.5"/><rect x="14" y="10" width="4" height="4" rx="0.5"/><line x1="6" y1="18" x2="6" y2="21"/><line x1="10" y1="18" x2="10" y2="21"/><line x1="14" y1="18" x2="14" y2="21"/><line x1="18" y1="18" x2="18" y2="21"/></svg>',
    'Processeur': '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><rect x="4" y="4" width="16" height="16" rx="2"/><rect x="9" y="9" width="6" height="6" rx="1"/><line x1="9" y1="1" x2="9" y2="4"/><line x1="15" y1="1" x2="15" y2="4"/><line x1="9" y1="20" x2="9" y2="23"/><line x1="15" y1="20" x2="15" y2="23"/><line x1="20" y1="9" x2="23" y2="9"/><line x1="20" y1="14" x2="23" y2="14"/><line x1="1" y1="9" x2="4" y2="9"/><line x1="1" y1="14" x2="4" y2="14"/></svg>',
    'RAM': '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><rect x="2" y="6" width="20" height="12" rx="1"/><line x1="6" y1="10" x2="6" y2="14"/><line x1="10" y1="10" x2="10" y2="14"/><line x1="14" y1="10" x2="14" y2="14"/><line x1="18" y1="10" x2="18" y2="14"/></svg>',
    'Stockage': '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><rect x="2" y="4" width="20" height="16" rx="2"/><circle cx="12" cy="12" r="4"/><circle cx="12" cy="12" r="1"/></svg>'
  };

  var FEAT_ICONS = {
    'Mont': '<svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><path d="M14.7 6.3a1 1 0 000 1.4l1.6 1.6a1 1 0 001.4 0l3.77-3.77a6 6 0 01-7.94 7.94l-6.91 6.91a2.12 2.12 0 01-3-3l6.91-6.91a6 6 0 017.94-7.94l-3.76 3.76z"/></svg>',
    '48': '<svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/></svg>',
    'jouer': '<svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><rect x="2" y="6" width="20" height="12" rx="2"/><line x1="6" y1="12" x2="10" y2="12"/><line x1="8" y1="10" x2="8" y2="14"/><circle cx="16" cy="10" r="1"/><circle cx="18" cy="13" r="1"/></svg>',
    'blage': '<svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><path d="M12 2v6m0 8v6M4.93 4.93l4.24 4.24m5.66 5.66l4.24 4.24M2 12h6m8 0h6M4.93 19.07l4.24-4.24m5.66-5.66l4.24-4.24"/></svg>',
    'Emballage': '<svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><path d="M21 16V8a2 2 0 00-1-1.73l-7-4a2 2 0 00-2 0l-7 4A2 2 0 003 8v8a2 2 0 001 1.73l7 4a2 2 0 002 0l7-4A2 2 0 0021 16z"/><polyline points="3.27 6.96 12 12.01 20.73 6.96"/><line x1="12" y1="22.08" x2="12" y2="12"/></svg>',
    'Support': '<svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><path d="M22 16.92v3a2 2 0 01-2.18 2 19.79 19.79 0 01-8.63-3.07 19.5 19.5 0 01-6-6 19.79 19.79 0 01-3.07-8.67A2 2 0 014.11 2h3a2 2 0 012 1.72c.127.96.361 1.903.7 2.81a2 2 0 01-.45 2.11L8.09 9.91a16 16 0 006 6l1.27-1.27a2 2 0 012.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0122 16.92z"/></svg>',
    'Garantie': '<svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/><polyline points="9 12 11 14 15 10"/></svg>'
  };

  function fixIcons() {
    document.querySelectorAll('.shwg-mini').forEach(function(el) {
      var ico = el.querySelector('.shwg-mini__ico');
      var label = el.querySelector('span');
      if (!ico || !label) return;
      var txt = label.textContent.trim();
      for (var k in MINI_ICONS) {
        if (txt.indexOf(k) !== -1) {
          ico.innerHTML = MINI_ICONS[k];
          ico.style.display = 'flex';
          ico.style.alignItems = 'center';
          ico.style.justifyContent = 'center';
          ico.style.color = '#0066FF';
          break;
        }
      }
    });
    document.querySelectorAll('.shwg-feat').forEach(function(el) {
      var ico = el.querySelector('.shwg-feat__ico');
      var h4 = el.querySelector('h4');
      if (!ico || !h4) return;
      var txt = h4.textContent.trim();
      for (var k in FEAT_ICONS) {
        if (txt.indexOf(k) !== -1) {
          ico.innerHTML = FEAT_ICONS[k];
          ico.style.display = 'flex';
          ico.style.alignItems = 'center';
          ico.style.justifyContent = 'center';
          ico.style.color = '#0066FF';
          break;
        }
      }
    });
  }

  function enhanceVariants() {
    var handle = window.location.pathname.split('/products/')[1];
    if (!handle) return;
    handle = handle.split('?')[0].split('#')[0];
    var xhr = new XMLHttpRequest();
    xhr.open('GET', '/products/' + handle + '.js', false);
    try { xhr.send(); } catch(e) { return; }
    if (xhr.status !== 200) return;
    var product = JSON.parse(xhr.responseText);
    if (!product || !product.variants || product.variants.length < 2) return;

    var selects = document.querySelectorAll('.shwg-form__select');
    selects.forEach(function(select) {
      var optionName = select.name.replace('options[', '').replace(']', '');
      var options = select.querySelectorAll('option');

      if (options.length <= 1) {
        select.style.display = 'none';
        var labels = select.parentElement.querySelectorAll('.shwg-form__label');
        labels.forEach(function(l) { if (l.textContent.trim() === optionName) l.style.display = 'none'; });
        var prev = select.previousElementSibling;
        if (prev && prev.classList.contains('shwg-form__label')) prev.style.display = 'none';
        return;
      }

      var optIdx = -1;
      if (product.options) {
        for (var i = 0; i < product.options.length; i++) {
          if (product.options[i] === optionName) { optIdx = i; break; }
        }
      }
      if (optIdx === -1) return;

      var priceMap = {};
      product.variants.forEach(function(v) {
        var val = v['option' + (optIdx + 1)];
        var p = v.price / 100;
        if (!priceMap[val] || p < priceMap[val]) priceMap[val] = p;
      });
      var basePrice = Infinity;
      for (var k in priceMap) { if (priceMap[k] < basePrice) basePrice = priceMap[k]; }

      var wrapper = document.createElement('div');
      wrapper.className = 'shwg-custom-sel';
      var selBtn = document.createElement('div');
      selBtn.className = 'shwg-custom-sel__btn';
      var selVal = select.options[select.selectedIndex] ? select.options[select.selectedIndex].value : '';
      var selDiff = priceMap[selVal] ? Math.round(priceMap[selVal] - basePrice) : 0;
      function updateBtn(val, diff) {
        selBtn.innerHTML = '<span class="shwg-cs__val">' + val + '</span>' + (diff > 0 ? '<span class="shwg-cs__diff">+ ' + diff + ' CHF</span>' : '') + '<svg class="shwg-cs__arr" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><polyline points="6 9 12 15 18 9"/></svg>';
      }
      updateBtn(selVal, selDiff);

      var dd = document.createElement('div');
      dd.className = 'shwg-custom-sel__dd';
      Array.from(options).forEach(function(opt) {
        var item = document.createElement('div');
        item.className = 'shwg-cs__opt' + (opt.value === selVal ? ' active' : '');
        var diff = priceMap[opt.value] ? Math.round(priceMap[opt.value] - basePrice) : 0;
        item.innerHTML = '<span>' + opt.value + '</span>' + (diff > 0 ? '<span class="shwg-cs__diff">+ ' + diff + ' CHF</span>' : '<span class="shwg-cs__diff shwg-cs__base">Base</span>');
        item.addEventListener('click', function() {
          select.value = opt.value;
          select.dispatchEvent(new Event('change', {bubbles: true}));
          var newDiff = priceMap[opt.value] ? Math.round(priceMap[opt.value] - basePrice) : 0;
          updateBtn(opt.value, newDiff);
          dd.querySelectorAll('.shwg-cs__opt').forEach(function(o) { o.classList.remove('active'); });
          item.classList.add('active');
          wrapper.classList.remove('open');
        });
        dd.appendChild(item);
      });
      wrapper.appendChild(selBtn);
      wrapper.appendChild(dd);
      selBtn.addEventListener('click', function(e) { e.stopPropagation(); wrapper.classList.toggle('open'); });
      document.addEventListener('click', function() { wrapper.classList.remove('open'); });
      select.style.display = 'none';
      select.parentNode.insertBefore(wrapper, select.nextSibling);
    });
  }

  function injectCSS() {
    var s = document.createElement('style');
    s.textContent = '.shwg-custom-sel{position:relative;width:100%;font-family:Inter,-apple-system,sans-serif;margin-bottom:12px}.shwg-custom-sel__btn{display:flex;align-items:center;gap:10px;padding:14px 18px;background:#fff;border:2px solid #e0e0e8;border-radius:12px;cursor:pointer;font-size:15px;font-weight:600;color:#1a1a2e;transition:all .2s}.shwg-custom-sel__btn:hover{border-color:#0066FF;box-shadow:0 2px 8px rgba(0,102,255,.08)}.shwg-custom-sel.open .shwg-custom-sel__btn{border-color:#0066FF;box-shadow:0 0 0 3px rgba(0,102,255,.1);border-radius:12px 12px 0 0}.shwg-cs__val{flex:1}.shwg-cs__diff{font-size:12px;font-weight:700;color:#0066FF;background:#f0f6ff;padding:3px 8px;border-radius:6px}.shwg-cs__base{color:#4caf50;background:#f0faf0}.shwg-cs__arr{flex-shrink:0;color:#7a7a92;transition:transform .2s}.shwg-custom-sel.open .shwg-cs__arr{transform:rotate(180deg)}.shwg-custom-sel__dd{position:absolute;top:100%;left:0;right:0;background:#fff;border:2px solid #0066FF;border-top:1px solid #e0e0e8;border-radius:0 0 12px 12px;box-shadow:0 8px 24px rgba(0,0,0,.12);z-index:50;display:none;overflow:hidden}.shwg-custom-sel.open .shwg-custom-sel__dd{display:block}.shwg-cs__opt{display:flex;align-items:center;justify-content:space-between;padding:14px 18px;cursor:pointer;font-size:14px;color:#1a1a2e;border-bottom:1px solid #f0f0f5;position:relative;transition:background .15s}.shwg-cs__opt:last-child{border-bottom:none}.shwg-cs__opt:hover{background:#f0f6ff}.shwg-cs__opt.active{background:#f0f6ff;font-weight:700}.shwg-cs__opt.active::before{content:\'\';position:absolute;left:0;top:0;bottom:0;width:3px;background:#0066FF}.shwg-mini__ico{width:32px;height:32px;display:flex;align-items:center;justify-content:center;flex-shrink:0}.shwg-feat__ico{width:36px;height:36px;display:flex;align-items:center;justify-content:center;flex-shrink:0}';
    document.head.appendChild(s);
  }

  function init() { injectCSS(); fixIcons(); enhanceVariants(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();